import {
  ChangeDetectionStrategy,
  Component, ContentChild, EventEmitter,
  Inject,
  Input, OnInit,
  Optional, Output, Self, TemplateRef
} from '@angular/core';
import {ControlValueAccessor, NgControl} from "@angular/forms";

require('./bringoz-radio-button.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-radio-button',
  templateUrl: './bringoz-radio-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozRadioButtonComponent implements ControlValueAccessor, OnInit {

  @Input() label = '';
  @Input() value!: any;
  @Input() name!: string;
  @Input() isSelected: boolean = false;
  @Input() isDisabled: boolean = false;
  @Output() onValueChange = new EventEmitter<string>();


  checked = false;

  constructor(@Optional() @Self() @Inject(NgControl) public control: NgControl) {
    if (this.control) {
      this.control.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    if (this.isSelected) {
      this.checked = true;
    }
  }

  writeValue(value: any): void {
    this.checked = value === this.value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onChange = (value: any) => {
  };
  onTouched = () => {
  };

  onInputChange() {
    this.onChange(this.value);
    this.onTouched();
    this.onValueChange.emit(this.value);
  }

}
